<template>
  <div v-if="refundData.refundShow && memberNo" class="refund-box">
    <div v-if="refundData.refunding" class="refund-ing" @click="jumpRefund">退款中，请耐心等待</div>
    <div v-else class="refund-btn" @click="jumpRefund">申请退款</div>
  </div>
</template>

<script>
export default {
  name: 'RefundBox',
  props: {
    // 退款单号
    memberNo: {
      type: String,
      default: ''
    },
    // 退款显示数据
    refundData: {
      type: Object,
      default: () => ({
        refundShow: false,
        refunding: false,
        refundWay: 'APPLY'
      })
    }
  },
  methods: {
    // 跳转申请退款页面
    jumpRefund () {
      let path = ''
      const query = {
        memberNo: this.memberNo
      }
      if (this.refundData.refunding) {
        path = '/refund'
      } else if (this.refundData.refundWay === 'APPLY') {
        path = '/refund'
      } else if (this.refundData.refundWay === 'SERVICE') {
        path = '/refund/service'
      }
      this.$router.push({
        path,
        query
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.refund-box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 100px;
  color: #999999;
  font-size: 28px;
  .refund-btn{
    width: 220px;
    height: 74px;
    border: 1PX solid #999999;
    border-radius: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
